/* eslint-disable */

import * as clientService from "./httpsClient";

export const getDestinationDeliveryPackage = async (accessToken, params) => {
  try {
    const domain = `destinationpackagedelivery`;
    return await clientService.getApi(domain, accessToken, params);
  } catch (error) {
    throw error;
  }
};

export const getAllDestinationPackageDelivery = async (accessToken, params) => {
  try {
    const domain = `destinationpackagedelivery/listall`;
    return await clientService.getApi(domain, accessToken, params);
  } catch (error) {
    throw error;
  }
};

export const createDestinationDeliveryPackage = async (accessToken, body) => {
  try {
    const domain = `destinationpackagedelivery`;
    return await clientService.postApi(domain, accessToken, body);
  } catch (error) {
    throw error;
  }
};

export const updateDestinationDeliveryPackage = async (accessToken, body) => {
  try {
    const domain = `destinationpackagedelivery`;
    return await clientService.putApi(domain, accessToken, body);
  } catch (error) {
    throw error;
  }
};
export const updateStatusDestinationDeliveryPackage = async (accessToken, body) => {
  try {
    const domain = `destinationpackagedelivery/update-status-deliver`;
    return await clientService.putApi(domain, accessToken, body);
  } catch (error) {
    throw error;
  }
};

export const changeDestinationDeliveryPackage = async (accessToken, id, body) => {
  try {
    const domain = `destinationpackagedelivery/${id}`;
    return await clientService.putApi(domain, accessToken, body);
  } catch (error) {
    throw error;
  }
};

export const deleteDestinationDeliveryPackage = async (accessToken, body) => {
  try {
    const domain = `destinationpackagedelivery`;
    return await clientService.deleteApi(domain, accessToken, body);
  } catch (error) {
    throw error;
  }
};

export const getContainerList = async (accessToken, params) => {
  try {
    const domain = `origintransportations/list-container`;
    return await clientService.getApi(domain, accessToken, params);
  } catch (error) {
    throw error;
  }
};
